import Vue from 'vue'
const AWS = require('aws-sdk')
const generateHash = () => {
    //http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
    )
}

const state = {}

const mutations = {}

const actions = {
    s3upload(context, files) {
        return new Promise((resolve, reject) => {
            if (!files || !files.length) {
                return reject(new Error('No Files!'))
            }
            const credentials = context.rootState.js_report.aws_credentials
            if (!credentials) { return reject(new Error('Missing Storage Credentials!')) }

            const keys = files.map(() => {
                return generateHash(); // Generate a unique key for each file.
            });

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;

            const Metadata = {
                webdomain,
                fileprefix,
                email
            }


            // upload multiple files
            for (let index = 0; index < files.length; index++) {
                // for(let file of files){
                const loadFile = Body => {
                    const params = {
                        Bucket,
                        Key: keys[index],
                        Body,
                        ContentType: files[index].type,
                        ContentDisposition: files[index].name,
                        Metadata
                    }
                    const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                    console.log('s3Files params', params)
                    s3.upload(params, options, err => {
                        if (err) {
                            console.error('s3Files err', err)
                            return reject(err)
                        }
                        console.log('s3 keys', keys)
                        /////const keys = Key; //.map(x => `${fileprefix}/${x}`)
                        const name = files[index].name
                        return resolve({ keys, name })
                    })
                }

                const reader = new FileReader()

                reader.onload = () => {
                    const fileData = new Uint8Array(reader.result)
                    //const fileBson = new BSON.Binary(fileData)
                    loadFile(fileData)
                }
                reader.readAsArrayBuffer(files[index])
            }
        })
    },
    
    s3singleUpload(context, files) {
        console.log('files', files)
        const Key = generateHash()
        const credentials = context.rootState.js_report.aws_credentials
        console.log('credentials:', credentials)
        return new Promise((resolve, reject) => {
            if (!credentials)
                return reject(new Error('Missing Storage Credentials!'))
            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                //key_path: Key,
                region,
                bucket: Bucket,
            } = credentials
            if (!accessKeyId || !secretAccessKey || !Bucket)
                return reject(new Error('Missing Storage Credentials!'))
            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            console.log('options', options)
            AWS.config.update(options)
            const s3 = new AWS.S3()

            const webdomain = context.rootGetters["web_domain"];
            const fileprefix = Vue.prototype.$MediaPrefix
            const { email } = context.rootState.user;

            const Metadata = {
                webdomain,
                fileprefix,
                email
            }

            if (files && files.length) {
                // upload multiple files
                for (let file of files) {

                    const loadFile = Body => {
                        const params = {
                            Bucket,
                            Key,
                            Body,
                            ContentType: file.type,
                            ContentDisposition: file.name,
                            Metadata
                        }
                        const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
                        console.log('s3Files params', params)
                        s3.upload(params, options, err => {
                            if (err) {
                                console.error('s3Files err', err)
                                return reject(err)
                            }
                            console.log('s3 Key', Key)
                            return resolve({ key: Key, name: file.name })
                        })
                    }

                    const reader = new FileReader()

                    reader.onload = () => {
                        const fileData = new Uint8Array(reader.result)
                        //const fileBson = new BSON.Binary(fileData)
                        loadFile(fileData)
                    }
                    reader.readAsArrayBuffer(file)

                }
            } else {
                console.log('no files')
            }
        })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
